import React, {useEffect, useState} from "react";
import TableWrapper from "../Table/tableWrapper";
import {generateAnalyticsTable} from "../../Util/TableHelpers/analyticsTableHelper";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";

let breakdownTableHeaders = ['Name', '# of completed deliveries', '% On-time deliveries', 'Avg. pickup to delivery time',  'Avg. placement to delivery time'];

const BreakdownTable = ({ analyticsData }) => {
    const { data: enterpriseAccountObj } = useFetchCompanyInfosQuery();
    const [tableArr, setTableArr] = useState([])

    useEffect(() => {
        if (analyticsData && enterpriseAccountObj) {
            setTableArr(generateAnalyticsTable(enterpriseAccountObj.getAccountsObj(), analyticsData.getFormattedData()));
        } else {
            setTableArr([]);
        }
    }, [analyticsData, enterpriseAccountObj]);

    return (
        <div className="row min-width-md-parent">
            <span className="sub-title">Breakdown by Companies</span>
            <TableWrapper tableHeaderArr={breakdownTableHeaders} tableBodyArr={tableArr} option={{firstRowWidth: 30}}/>
        </div>
    )
}

export default BreakdownTable;
